import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button, Space, Typography, Avatar } from 'antd';
import {
  HomeOutlined,
  SearchOutlined,
  ProfileOutlined,
  MessageOutlined,
  LogoutOutlined,
  CarOutlined,
} from '@ant-design/icons';
import { usePortalStore } from '../store/portalStore';
import { portalApi } from '../api/portal';

const { Header, Content, Footer } = Layout;
const { Text } = Typography;

const navItems = [
  { key: '/portal/home', icon: <HomeOutlined />, label: 'Ballina' },
  { key: '/portal/book', icon: <SearchOutlined />, label: 'Rezervo' },
  { key: '/portal/tickets', icon: <ProfileOutlined />, label: 'Biletat e mia' },
  { key: '/portal/complaints', icon: <MessageOutlined />, label: 'Ankesat' },
];

const PortalLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { passenger, logout } = usePortalStore();

  const handleLogout = async () => {
    try {
      await portalApi.logout();
    } catch {
      /* ignore */
    }
    logout();
    navigate('/portal/login');
  };

  const selected = navItems.find((i) => location.pathname.startsWith(i.key))?.key ?? '/portal/home';

  return (
    <Layout style={{ minHeight: '100vh', background: '#f5f6fa' }}>
      <Header
        style={{
          background: '#0f172a',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 24px',
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        <Space>
          <CarOutlined style={{ fontSize: 22, color: '#fff' }} />
          <span style={{ color: '#fff', fontSize: 18, fontWeight: 700 }}>
            MTS — Portali i Pasagjerit
          </span>
        </Space>
        <Space size="middle">
          {passenger && (
            <>
              <Avatar size="small" icon={<CarOutlined />} style={{ background: '#2563eb' }} />
              <Text style={{ color: '#fff' }}>{passenger.full_name}</Text>
              <Button type="text" icon={<LogoutOutlined />} style={{ color: '#fff' }} onClick={handleLogout}>
                Dil
              </Button>
            </>
          )}
        </Space>
      </Header>

      <Menu
        mode="horizontal"
        selectedKeys={[selected]}
        items={navItems}
        onClick={({ key }) => navigate(key)}
        style={{ background: '#fff', marginBottom: 16, justifyContent: 'center' }}
      />

      <Content style={{ padding: '0 24px', maxWidth: 960, margin: '0 auto', width: '100%' }}>
        <Outlet />
      </Content>

      <Footer style={{ textAlign: 'center', background: 'transparent' }}>
        <Text type="secondary">MTS Transport DOOEL Skopje — Portali i Pasagjerit</Text>
      </Footer>
    </Layout>
  );
};

export default PortalLayout;
